module Widgets.Form.Radio where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import Data.Maybe (maybe)
import GraphQL.Shape (QueryField(..))
import Widgets.Form.Class (class FormWidget, FormContext, fieldAccessProps, formWidgetState, fieldClass, fieldId, setFromJson)
import Widgets.Form.Common (widgetLabel', widgetLabelS')

newtype Radio = Radio RadioType
derive newtype instance showRadio :: Show Radio
type RadioType =
    { id :: String
    , label :: String
    , cls :: String
    , options :: Array RadioOption
    , value :: Maybe String
    }
type RadioOption =
    { value :: String
    , label :: String
    }


instance radioFW :: FormWidget Radio where
    getId (Radio state) = state.id
    isLeaf _ = true
    asField (Radio state) = Just $ QScalar state.id
    fieldPaths fc (Radio state) = [ fieldId fc state.id ]

    toWidget fc (Radio state) = formWidgetState <$>
        Radio <$> (\v -> state { value = Just v })
              <$> D.div [P.key $ fieldId fc state.id, P.className $ fieldClass state ]
               ([ widgetLabelS' fc state ]
                <> map (radioOption fc state) state.options)

    getData _ (Radio state) = maybe J.jsonNull J.fromString state.value
    setData fc st@(Radio state) = setFromJson st $ \val' ->
        case val' of
             Nothing -> Right $ Radio $ state { value = Nothing }
             Just val | any (\opt -> opt.value == val) state.options ->
                 Right $ Radio $ state { value = Just val }
             Just val -> Left $ StringError (val <> " is not an option in radio " <> fieldId fc state.id)

radioOption :: FormContext -> RadioType -> RadioOption -> Widget HTML String
radioOption fc state opt = D.div'
    [ D.input
        ( [ P._type "radio", P._id id, P.name id, P.value opt.value
        , P.checked selected, opt.value <$ P.onChange
        ] <> fieldAccessProps fc state.id )
    , widgetLabel' id opt.label
    ]
    where id = fieldId fc state.id <> "." <> opt.value
          selected = state.value == Just opt.value
